export enum BlockArrayTypes {
  SCHEDULES = 'schedules',
  CARDS = 'cards',
  TABLE = 'table',
  CHIP_LIST = 'chip_list',
  TABLE_VIEW = 'tableView',
}

export enum BlockArrayModels {
    RULE = 'rule',
    SCHEDULE_RANGE = 'schedule_range',
}

export interface IBlockArray {
  dataPath: string
  schema: any
  title: string
  description?: string
  wrapper?: string
  levelDeep?: number
  isViewOnly?: boolean
  element_id?: string
  inCard?: boolean
  isRuleActive?: boolean
  pathWithElementID?: string[]
  isParentDisabled?: boolean
}

export interface IBlockArrayTableRow {
  data: any
  items: any[]
  index: number
  focusIndex: number
  onItemFocus: (index: number) => void
  schema?: any
  parentSchema?: any
  dataPath?: string[]
  title: string
  isOrderUserDefined: boolean
}

export interface IMultiSelectProps {
  data: any
  dataSchema: any
  name: string
  wrapper?: string
  dataPath?: string[]
  levelDeep?: number
  isViewOnly?: boolean
  element_id?: string
  inCard?: boolean
  isRuleActive?: boolean
  pathWithElementID?: string[]
}

export interface IMultiSelectAdvanced {
  data: any
  name: string
  path: string[]
  schema: any
}

export interface IMultiSelectAdvancedRow {
  item: any
  path: string[]
  state: any
  setState: any
  schema: any
  name: string
}
